import {Component, OnInit, OnDestroy ,ViewChild} from '@angular/core';
import {NotifierService} from 'angular-notifier';
import {Formatters} from 'angular-slickgrid';
import {MessageService} from '../message.service';
import {CustomInputEditor} from '../custom-inputEditor';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
    selector: 'app-menu-url',
    templateUrl: './menu-url.component.html',
    styleUrls: ['./menu-url.component.css']
})
export class MenuUrlComponent implements OnInit, OnDestroy {

    displayed = true;
    selected: number;
    clientSelected: number;
    parentSelected: number;
    moduleSelected: number;
    show: boolean;
    totalData: number;
    selectedTitles: any[];
    respObject: any;
    clients = [];
    module = [];
    parents = [];
    clientName: string;
    moduleName: string;
    parentName: string;
    name: string;
    sequence: string;
    displayData: any;

    add: boolean;
    del: boolean;
    edit: boolean;
    view: boolean;

    isError = false;
    errorMessage: string;

    private notifier: NotifierService;
    public urls: any;
    urlSelected: number;
    private url: any;
    nextOffset: number;
    previousOffset: number;
    pageSize: number;
    paginationType: string;
    page_no: number;
    totalPage: number;
    clientId: number;
    private baseFlag: any;
    private adminAuth: Subscription;
    offset: number;
    private radioChecked: any;
    dataLoaded:boolean;
    showSearch = true;
    isLoading = false;
    searchData: FormControl = new FormControl();
    menuSelected: any;
    menus: any;
    menuUrl: string;
    showExportBtn = true;
    dataExcel = [];
    isExportDisable = false;

    @ViewChild('scarch_content') private scarch_content;
    private searchModalReference: NgbModalRef;


    constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
                private modalService: NgbModal, notifier: NotifierService) {
        this.notifier = notifier;
        this.messageService.getCellChangeData().subscribe(item => {
            switch (item.type) {
                case 'change':
                    console.log('changed');
                    if (!this.edit) {
                        this.notifier.notify('error', 'You do not have edit permission');
                    } else {

                    }
                    break;
                case 'delete':
                    console.log('deleted');
                    if (!this.del) {
                        this.notifier.notify('error', 'You do not have delete permission');
                    } else {
                        if (confirm('Are you sure?')) {
                            this._rest.deleteMapModuleRole({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
                                this.respObject = res;
                                if (this.respObject.success) {
                                    this.messageService.sendAfterDelete(item.id);
                                } else {
                                    this.notifier.notify('error', this.respObject.errorMessage);
                                }
                            }, (err) => {
                                this.notifier.notify('error', this.respObject.errorMessage);
                            });
                        }
                    }
                    break;
            }
        });
        this.messageService.getUserAuth().subscribe(details => {
            console.log(JSON.stringify(details));
            if (details.length > 0) {
                this.add = details[0].addFlag;
                this.del = details[0].deleteFlag;
                this.view = details[0].viewFlag;
                this.edit = details[0].editFlag;
            } else {
                this.add = false;
                this.del = false;
                this.view = false;
                this.edit = false;
            }
        });
        this.messageService.getSelectedItemData().subscribe(selectedTitles => {
            if (selectedTitles.length > 0) {
                this.show = true;
                this.selected = selectedTitles.length;
            } else {
                this.show = false;
            }
        });
    }

    ngOnInit() {
        this.dataLoaded=false;
        this.nextOffset = 0;
        this.previousOffset = 0;
        this.pageSize = this.messageService.pageSize;
        this.page_no = 0;
        this.totalPage = 0;
        this.paginationType = 'next';
        this._rest.getClient().subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.respObject.clients.unshift({id: 0, name: 'Select Client'});
                this.clients = this.respObject.clients;
                this.clientSelected = 0;
            } else {
            }
        }, (err) => {

        });
        this.displayData = {
            pageName: 'View Menu URL Mapping',
            openModalButton: 'Map Menu and URL',
            searchModalButton: 'Search',
            breadcrumb: 'menuUrl',
            folderName: 'All Menu with URL',
            tabName: 'Menu Url',
            exportBtn: 'Export to excel'

        };
        const columnDefinitions = [
            {
                id: 'delete',
                field: 'id',
                excludeFromHeaderMenu: true,
                formatter: Formatters.deleteIcon,
                minWidth: 30,
                maxWidth: 30,
            },
            // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
            {
                id: 'name', name: 'Menu', field: 'name', sortable: true, filterable: true
            },
            {
                id: 'module', name: 'Module', field: 'module_name', sortable: true, filterable: true
            },
            {
                id: 'client_name', name: 'Client ', field: 'client_name', sortable: true, filterable: true
            },
            {
                id: 'url', name: 'Url ', field: 'url', sortable: true, filterable: true
            }
        ];
        this.messageService.setColumnDefinitions(columnDefinitions);
        if (this.messageService.clientId) {
            this.clientId = this.messageService.clientId;
            this.baseFlag = this.messageService.baseFlag;
            this.onPageLoad();
        } else {
            this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
                if (details.length > 0) {
                    this.add = details[0].addFlag;
                    this.del = details[0].deleteFlag;
                    this.view = details[0].viewFlag;
                    this.edit = details[0].editFlag;
                    this.clientId = details[0].clientId;
                    this.baseFlag = details[0].baseFlag;
                    this.onPageLoad();
                }
            });
        }
        this.searchData.valueChanges.subscribe(
            name => {
                if (name.length > 3) {
                    this.isLoading = true;
                    this._rest.searchAllCreateMenu( name, this.clientId).subscribe((res1) => {
                        this.respObject = res1;
                        this.isLoading = false;
                        if (this.respObject.success) {
                            this.menus = this.respObject.details;
                            // console.log("true"+ JSON.stringify(this.menus));
                        } else {
                            this.notifier.notify('error', this.respObject.errorMessage);
                        }
                    }, (err) => {
                        this.isLoading = false;
                        this.notifier.notify('error', this.messageService.SERVER_ERROR);
                    });
                } else {
                    this.menus = [];
                }
            });
    }

    onPageLoad() {
        this.getTableData();
    }

    changeRouting(path: string) {
        this.messageService.changeRouting(path);
    }

    onClientChange(selectedIndex) {
        this.clientName = this.clients[selectedIndex].name;
        this._rest.getModulesByClientId(this.clientSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                this.isError = false;
                this.respObject.modules.unshift({id: 0, name: 'Select Modules'});
                this.module = this.respObject.modules;
                this.moduleSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });

    }

    exportToExcel() {
        this.isExportDisable = true;

        // console.log("okkk" +this.clientId);
        this._rest.getAllUrlWithMenus(this.clientId).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
                this.isExportDisable = false;

                this.dataExcel = this.respObject.details;
                // console.log('true' + JSON.stringify(this.dataExcel));
                this.messageService.exportAsExcelFile(this.dataExcel);
            } else {
                this.notifier.notify('error', this.respObject.errorMessage);
            }
        }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
        });
    }



    openModal(content) {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.parentSelected = 0;
            this.moduleSelected = 0;
            this.parents = [];
            this.urls=[];
            this.modalService.open(content, {size: 'sm'}).result.then((result) => {
            }, (reason) => {
            });
        }
    }

    searchModal() {
        if (!this.add) {
            this.notifier.notify('error', 'You do not have add permission');
        } else {
            this.isError = false;
            this.clientSelected = 0;
            this.parentSelected = 0;
            this.moduleSelected = 0;
            this.parents = [];
            this.urls=[];
            this.menuUrl = '';
            this.menuSelected = '';
            this.searchModalReference = this.modalService.open(this.scarch_content);
            this.searchModalReference.result.then((result) => {
            }, (reason) => {

            });
        }
    }


    getDetails() {
        for (let i = 0; i < this.menus.length; i++) {
            if (this.menus[i].name === this.menuSelected) {
              
                this.menuUrl = this.menus[i].url;
            }
        }
    }
    search() {
      const data1 = [];
      for (let i = 0; i < this.menus.length; i++) {
          if (this.menus[i].name === this.menuSelected) {
            data1.push(this.menus[i]);
          }
      }
      this.page_no = 1;
      this.messageService.setTotalData(data1.length);
      this.messageService.setGridData(data1);
      this.searchModalReference.close();

    }

    save() {
        const data = {
            id: this.parentSelected,
            urlId: this.urlSelected,
            createdBy: this.messageService.getUserId()
        };
        console.log(JSON.stringify(data));
        if (!this.messageService.isBlankField(data)) {
            this._rest.updateMenuDtlsWithUrlClientWise(data).subscribe((res) => {
                this.respObject = res;
                if (this.respObject.success) {
                    this.isError = false;
                    this.nextOffset = 0;
                    this.page_no = 0;
                    this.getTableData();
                    this.clientSelected = 0;
                    this.moduleSelected = 0;
                    this.parentSelected = 0;
                    this.urlSelected = 0;
                } else {
                    this.isError = true;
                    this.errorMessage = this.respObject.errorMessage;
                }
            }, (err) => {
                this.isError = true;
                this.errorMessage = this.messageService.SERVER_ERROR;
            });
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    getTableData() {
        if (!this.view) {
            this.notifier.notify('error', 'You do not have view permission');
        } else {
            this.getData({'offset': this.nextOffset, 'paginationType': ''});
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getData(paginationObj) {
        const offset = paginationObj.offset;
        const paginationType = paginationObj.paginationType;
        this.dataLoaded=false;
        this._rest.getMenuCompleteDtlsClientWise(offset, this.pageSize, paginationType).subscribe((res) => {
            this.respObject = res;
            console.log("data"+JSON.stringify(this.respObject));
            this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
            this.notifier.notify('error', err);
        });
    }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded=true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    onPageSizeChange(value: any) {
        this.page_no = 0;
        this.nextOffset = 0;
        this.pageSize = value;
        this.getData({'offset': this.nextOffset, 'paginationType': ''});
    }

    onRadioButtonChange(selectedValue) {
        this.radioChecked = selectedValue.value;
        this.parents = [];
        this.getMenu();
    }

    getMenu() {
        if (this.moduleSelected > 0 && this.clientSelected > 0) {
            if (this.radioChecked === 1) {
                this._rest.getMappedLeafMenu(this.clientSelected, this.moduleSelected).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({id: 0, name: 'Select Menu'});
                        this.parents = this.respObject.details;
                        this.parentSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            } else {
                this._rest.getUnmappedLeafMenu(this.clientSelected, this.moduleSelected).subscribe((res) => {
                    this.respObject = res;
                    if (this.respObject.success) {
                        this.isError = false;
                        this.respObject.details.unshift({id: 0, name: 'Select Menu'});
                        this.parents = this.respObject.details;
                        this.parentSelected = 0;
                    } else {
                        this.isError = true;
                        this.errorMessage = this.respObject.errorMessage;
                    }
                }, (err) => {
                    this.isError = true;
                    this.errorMessage = this.messageService.SERVER_ERROR;
                });
            }
        } else {
            this.isError = true;
            this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
        }
    }

    onModuleChange(selectedIndex: any) {
        this.moduleName = this.module[selectedIndex].name;
        this.parents = [];
        this.getMenu();
        this._rest.getModuleUrl(this.moduleSelected, this.clientSelected).subscribe((res) => {
            this.respObject = res;
            if (this.respObject.success) {
                // console.log(JSON.stringify(this.respObject));
                this.isError = false;
                this.respObject.urls.unshift({id: 0, url: 'Select Url '});
                this.urls = this.respObject.urls;
                this.urlSelected = 0;
            } else {
                this.isError = true;
                this.errorMessage = this.respObject.errorMessage;
            }
        }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
        });
    }

    onParentChange(selectedIndex: any) {
        this.parentName = this.parents[selectedIndex].name;
    }

    onUrlChange(value: any) {
        this.url = this.urls[value].url;

    }

    ngOnDestroy(): void {
        if (this.adminAuth) {
            this.adminAuth.unsubscribe();
        }
    }
}
